import React from "react";
import "./style.css";
import Sidedrawer from "../sidedrawer";

class Sidebar extends React.Component {
  state = {
    drawerState: false,
  };

  toggleDrawer = () => {
    this.setState((prevState) => {
      return { drawerState: !prevState.drawerState };
    });
  };

  render() {
    //Side Drawer
    var sidedrawer = (
      <Sidedrawer
        drawerState={this.state.drawerState}
        toggleDrawer={this.toggleDrawer}
      />
    );

    var sidebarLineCss = "sidebar-line";
    var sidebar = "sidebar";
    if (this.state.drawerState) {
      sidebarLineCss = "sidebar-line open";
      sidebar = "sidebar open";
    }

    return (
      <>
        {sidedrawer}
        <button className={sidebar} onClick={this.toggleDrawer}>
          {this.state.drawerState ? (
            <>
              <div className="sidebar-line open rotate-left" />
              <div className="sidebar-line open center"></div>
              <div className="sidebar-line open rotate-right" />
            </>
          ) : (
            <>
              <div className={sidebarLineCss} />
              <div className={sidebarLineCss} />
              <div className={sidebarLineCss} />
            </>
          )}
        </button>
      </>
    );
  }
}

export default Sidebar;
